module.exports = __webpack_public_path__ + "img/0xc234A67a4F840E61adE794be47de455361b52413.2a17ad98.png";